import React from 'react';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';

export default function ActivityTab({ activities, fetchActivity, formatDate, getActivityIcon }) {
  return (
    <div className="bg-white rounded-xl shadow-md" data-testid="activity-tab">
      <div className="p-4 border-b border-gray-200 flex justify-between items-center">
        <h3 className="font-semibold text-gray-900">Recent Activity</h3>
        <Button onClick={fetchActivity} variant="outline" size="sm">
          <RefreshCw className="h-4 w-4" />
        </Button>
      </div>
      <div className="divide-y divide-gray-200">
        {activities.map((activity, index) => (
          <div key={`${activity.type}-${activity.timestamp}-${index}`} className="p-4 flex items-start space-x-4">
            <div className="p-2 bg-gray-100 rounded-full">{getActivityIcon(activity.type)}</div>
            <div className="flex-1">
              <p className="text-gray-900">
                {activity.type === 'new_user' && `New ${activity.data.user_type}: ${activity.data.name}`}
                {activity.type === 'new_job' && `New job: ${activity.data.title}`}
                {activity.type === 'new_application' && `New application submitted`}
              </p>
              <p className="text-sm text-gray-500">{formatDate(activity.timestamp)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
